import Icons from "../assets/icon/index";
const userRollData = [
    {
        id: 1,
        title: "PREMIUM FAN",
        bgColor: "#017872",
        icon: Icons.rollFanIcons,
        comingSoon: 'Coming Soon',
    },
    {
        id: 2,
        title: "TALENT",
        bgColor: "#FC3636",
        icon: Icons.rollTALENTIcons,
        to: "/talent-register"
    },
    {
        id: 3,
        title: "EMPLOYER",
        bgColor: "#FC7336",
        icon: Icons.rollEMYIcons,
        // to: "/employer-register"
        comingSoon: 'Coming Soon',
    },
    {
        id: 4,
        title: "AGENCY",
        bgColor: "#433878",
        icon: Icons.rollAGENCYIcons,
        comingSoon: 'Coming Soon',
    },
    {
        id: 5,
        title: "VENDOR",
        bgColor: "#700043",
        icon: Icons.rollVendercons,
        comingSoon: 'Coming Soon',
    },
    {
        id: 6,
        title: "PROMOTIONAL PARTNER",
        bgColor: "#2F54CC",
        icon: Icons.rollPARTNERIcons,
        comingSoon: 'Coming Soon',
    },
];
export default userRollData;